import React from 'react'
import {Box, Flex, Link, LinkProps, Stack} from '@chakra-ui/react'
import {
  faFacebook,
  faInstagram,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons'
import {
  faEnvelope as fasEnvelope,
  faFileAlt as fasFileAlt,
  faInfoCircle as fasInfoCircle,
  faLock as fasLock,
  faQuestion as fasQuestion,
  faQuestionCircle as fasQuestionCircle,
  faUsers as fasUsers,
} from '@fortawesome/pro-solid-svg-icons'

import {FontAwesomeIcon} from 'components/FontAwesomeIcon'

export function Footer() {
  return (
    <Flex
      as="footer"
      align="center"
      bg="#231f20"
      h={12}
      justify="space-around"
      maxW="container.xl"
      mx="auto"
      px={4}
      w="100%"
    >
      <Stack direction="row" spacing={4}>
        <FooterLink href="https://twitter.com/pickuphub">
          <FontAwesomeIcon icon={faTwitter} />
        </FooterLink>
        <FooterLink href="https://facebook.com/pickuphub">
          <FontAwesomeIcon icon={faFacebook} />
        </FooterLink>
        <FooterLink href="https://instagram.com/pickuphub">
          <FontAwesomeIcon icon={faInstagram} />
        </FooterLink>
      </Stack>

      <Stack direction="row" spacing={4}>
        <FooterLink href="/how-it-works">
          <FontAwesomeIcon icon={fasInfoCircle} />
          <Box ml={1}>How It Works</Box>
        </FooterLink>
        <FooterLink href="/faq">
          <FontAwesomeIcon icon={fasQuestionCircle} />
          <Box ml={1}>FAQs</Box>
        </FooterLink>
        <FooterLink href="https://about.pickuphub.net">
          <FontAwesomeIcon icon={fasUsers} />
          <Box ml={1}>Become a Host</Box>
        </FooterLink>
        <FooterLink href="/privacy-policy">
          <FontAwesomeIcon icon={fasLock} />
          <Box ml={1}>Privacy Policy</Box>
        </FooterLink>
        <FooterLink href="/terms-of-use">
          <FontAwesomeIcon icon={fasFileAlt} />
          <Box ml={1}>Terms of Use</Box>
        </FooterLink>
      </Stack>

      <Stack direction="row" spacing={4}>
        <FooterLink href="mailto:sales@pickuphub.net">
          <FontAwesomeIcon icon={fasEnvelope} />
        </FooterLink>
        <FooterLink href="mailto:info@pickuphub.net">
          <FontAwesomeIcon icon={fasQuestion} />
        </FooterLink>
      </Stack>

      <Box color="silver" fontSize="xs">
        &copy; {new Date().getFullYear()} PickupHub Inc.
      </Box>
    </Flex>
  )
}

function FooterLink(props: LinkProps) {
  return (
    <Link
      {...props}
      alignItems="center"
      color="silver"
      d="flex"
      fontSize="xs"
      _hover={{color: `white`}}
    />
  )
}
